import {
  Box,
  Divider,
  FieldRichText,
  FieldText,
  FieldTextarea,
  Text,
} from '@dixa/lib-shared-habla';

import { SanitizeHTML } from 'app/utils/htmlSanitizer';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { elevioActions } from '../../../elevio.actions';
import { elevioSelectors } from '../../../elevio.reducer/selectors';
import { noOp } from '../../../utils';

import styles from './ResolutionModalBody.module.scss';

export function ResolutionDraftForm(): JSX.Element | null {
  const dispatch = useAppDispatch();
  const draft = useAppSelector(elevioSelectors.resolution.draft);

  if (!draft) return null;

  const { ticket, question, notes } = draft;

  const onChangeInitialQuestion = (e?: React.ChangeEvent<HTMLInputElement>) => {
    if (!e) return;
    dispatch(
      elevioActions.resolution.setResolutionDraftQuestion({
        question: e.currentTarget.value,
      }),
    );
  };

  const onChangeNotes = (e?: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (!e) return;
    dispatch(
      elevioActions.resolution.setResolutionDraftNotes({
        notes: e.currentTarget.value,
      }),
    );
  };

  const onChangeArticleContent = (articleContent?: string) => {
    if (!articleContent) return;
    dispatch(
      elevioActions.resolution.setResolutionArticleContent({
        articleContent,
      }),
    );
  };

  return (
    <>
      <Divider className={styles.section} />
      <Box className={styles.section}>
        <Text.Heading
          className={styles.title}
          variant="heading-3"
          color="primary"
        >
          Draft Article
        </Text.Heading>
        <FieldText
          label="Conversation"
          onKeyDown={noOp} // callback not required - always a disabled field
          disabled={true}
          input={{
            value: ticket,
            name: 'ticketField',
            onChange: noOp, // callback not required - always a disabled field
          }}
        />
        <FieldText
          label="Initial question"
          input={{
            value: question,
            name: 'initialQuestionField',
            onChange: onChangeInitialQuestion,
          }}
        />
        <FieldTextarea
          label="Notes"
          input={{
            value: notes,
            name: 'notesField',
            onChange: onChangeNotes,
          }}
        />
        <FieldRichText
          allowFormatting
          label="Article Content"
          input={{
            name: 'articleContentField',
            onChange: onChangeArticleContent,
            value: draft.articleContent,
          }}
          sanitize={SanitizeHTML.sanitizerForProfile('emailShadowDom')}
        />
      </Box>
    </>
  );
}
